/*
 * Tooltip
 */

// LE BUT EST D'AVOIR UN MÊME COMPOSANT EN:
//  - Vue
//  - Razor (server side TagHelper)
//  - Vanilla Js

/// 1. create from JS:
//const node = builder.component('p-tooltip', { placeholer: '' }); // create like razor taghelper + attachTooltip(node)

import { initTooltip } from "../directives/tooltip";

const attachTooltip = (node) => {
  initTooltip(node, {
    value: node.getAttribute("v-tooltip"),
  });
};

const createTooltip = (attributes) => {};

const razorTooltip = {
  selector: "[v-tooltip]",
  create: createTooltip,
  attach: attachTooltip,
};

export default razorTooltip;
